export const PERMISSIONS = [
	"add_member",
	"assign_user_role",
	"assign_warehouse_manager",
	"change_warehouse_manager",
	"disable_user_account",
	"enable_user_account",
	"edit_member_role",
	"update_business_settings",
	"add_tag",
	"update_tag",
	"delete_tag",
	"approve_inventory_request",
	"view_store_requests",
	"view_all_store_requests",
	"add_bank_account",
	"disable_bank_account",
	"update_bank_account",
	"enable_bank_account",
	"view_reconciliation",
	"view_settlements",
	"add_entity",
	"update_entity",
	"add_role",
	"update_role",
	"delete_role",
	"view_business_tier",
	"view_invoices",
	"view_payment",
	"view_dashboard",
	"view_wallet_balance",
	"view_wallet_account",
];

export const NOTIFICATIONS_SETTINGS = {
	sms: [
		{ name: "invoice", value: "sms_invoice", description: "Receive SMS notifications when invoices are created" },
		{ name: "inflow", value: "sms_inflow", description: "Receive SMS notifications for inflow transactions" },
		{ name: "payout", value: "sms_payout", description: "Receive SMS notifications for payout transactions" },
		{ name: "requests", value: "sms_requests", description: "Receive SMS notifications for requests" },
		{ name: "product_in", value: "sms_product_in", description: "Receive SMS notifications when products are added to inventory" },
		{ name: "product_out", value: "sms_product_out", description: "Receive SMS notifications when products are removed from inventory" },
	],
	email: [
		{ name: "invoice", value: "email_invoice", description: "Receive email notifications when invoices are created" },
		{ name: "inflow", value: "email_inflow", description: "Receive email notifications for inflow transactions" },
		{ name: "payout", value: "email_payout", description: "Receive email notifications for payout transactions" },
		{ name: "requests", value: "email_requests", description: "Receive email notifications for requests" },
		{ name: "product_in", value: "email_product_in", description: "Receive email notifications when products are added to inventory" },
		{ name: "product_out", value: "email_product_out", description: "Receive email notifications when products are removed from inventory" },
	],
};
